function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/jsx-handler-names, no-return-assign */
import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';
import { DayPickerRangeController } from 'react-dates';
import Row from 'react-bootstrap/es/Row';
import Col from 'react-bootstrap/es/Col';
import ClickOutside from 'react-click-outside';
import moment from 'moment';
import { get as getIn, omit } from 'lodash';
import CalendarIcon from "../icon-components/calendar";
import LeftPaginationArrow from "../icon-components/left-pagination-arrow";
import RightPaginationArrow from "../icon-components/right-pagination-arrow";
import noop from "../utils/noop";

var RangeDateInput =
/*#__PURE__*/
function (_Component) {
  _inherits(RangeDateInput, _Component);

  function RangeDateInput(props) {
    var _this;

    _classCallCheck(this, RangeDateInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeDateInput).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focusedInput: null,
      start: null,
      end: null
    });

    _defineProperty(_assertThisInitialized(_this), "onDatesChange", function (dates) {
      var _this$props = _this.props,
          onDatesChange = _this$props.onDatesChange,
          selectMode = _this$props.selectMode;
      var focusedInput = _this.state.focusedInput;
      var isStartDate = focusedInput === 'startDate';
      if (isStartDate) _this.focusEnd();else _this.blur();

      if (selectMode !== 'day') {
        var changedDate = (isStartDate ? dates.startDate : dates.endDate).clone();

        if (selectMode === 'release week') {
          var isFridayOrMore = changedDate.isoWeekday() >= 5;
          if (isStartDate) changedDate.isoWeekday(isFridayOrMore ? 5 : -2);else changedDate.isoWeekday(isFridayOrMore ? 11 : 4);
        } else {
          var method = isStartDate ? 'startOf' : 'endOf';
          changedDate[method](selectMode);
        }
        /* eslint-disable no-param-reassign */


        if (isStartDate) dates.startDate = changedDate;else dates.endDate = changedDate;
        /* eslint-enable no-param-reassign */
      }

      onDatesChange(dates);
    });

    _defineProperty(_assertThisInitialized(_this), "isOutsideRange", function (day) {
      var _this$props2 = _this.props,
          minDate = _this$props2.minDate,
          maxDate = _this$props2.maxDate;
      if (minDate && maxDate) return !day.isBetween(minDate, maxDate, 'day', '[]');
      if (minDate) return !day.isSameOrAfter(minDate, 'day');
      if (maxDate) return !day.isSameOrBefore(maxDate, 'day');
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      var focusedInput = _this.state.focusedInput;

      _this.setState(focusedInput ? {
        focusedInput: null,
        start: null,
        end: null
      } : {
        focusedInput: 'startDate',
        end: null
      });

      if (!focusedInput && _this.startDateInput) _this.startDateInput.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      _this.updateDatesFromState();

      if (_this.startDateInput) _this.startDateInput.focus();

      _this.setState({
        focusedInput: 'startDate',
        end: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "focusEnd", function () {
      _this.updateDatesFromState();

      if (_this.endDateInput) _this.endDateInput.focus();

      _this.setState({
        focusedInput: 'endDate',
        start: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      _this.updateDatesFromState();

      if (_this.startDateInput) _this.startDateInput.blur();
      if (_this.endDateInput) _this.endDateInput.blur();

      _this.setState({
        focusedInput: null,
        start: null,
        end: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleManuallyChange", function (name) {
      return function (e) {
        var isManuallyEditable = _this.props.isManuallyEditable; // disable manual edit if we have formatter for this field

        if (!isManuallyEditable || _this.props["".concat(name, "Formatter")]) return;
        var stringValue = getIn(e, ['target', 'value'], e);

        _this.setState(_defineProperty({}, name, stringValue));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (_this.props.keyboardNavigationEnabled) if (_this.dayPickerRangeController) {
        var dayPicker = _this.dayPickerRangeController.dayPicker;
        if (dayPicker) dayPicker.onKeyDown(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateDatesFromState", function () {
      var _this$props3 = _this.props,
          isManuallyEditable = _this$props3.isManuallyEditable,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate,
          onDatesChange = _this$props3.onDatesChange,
          dateFormat = _this$props3.dateFormat;
      var _this$state = _this.state,
          focusedInput = _this$state.focusedInput,
          start = _this$state.start,
          end = _this$state.end;
      if (!isManuallyEditable || !focusedInput) return;

      var getDate = function getDate(propDate, stateDate) {
        var result = propDate;
        if (stateDate !== null) if (!stateDate) result = null;else {
          var momentDate = moment(stateDate, dateFormat);
          if (momentDate.isValid()) result = momentDate;
        }
        return result;
      };

      var dates = {
        startDate: getDate(startDate, start),
        endDate: getDate(endDate, end)
      }; // check if dates in correct order: startDate <= endDate

      if (dates.startDate && dates.endDate) if (focusedInput === 'startDate' && dates.startDate.clone().startOf('day').isAfter(dates.endDate.clone().startOf('day'))) dates.endDate = null;else if (focusedInput === 'endDate' && dates.endDate.clone().startOf('day').isBefore(dates.startDate.clone().startOf('day'))) dates.startDate = null;
      onDatesChange(dates);
    });

    _this.dayPickerRangeController = createRef();
    return _this;
  }

  _createClass(RangeDateInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          startName = _this$props4.startName,
          endName = _this$props4.endName,
          startDate = _this$props4.startDate,
          endDate = _this$props4.endDate,
          dateFormat = _this$props4.dateFormat,
          startPlaceholder = _this$props4.startPlaceholder,
          endPlaceholder = _this$props4.endPlaceholder,
          startFormatter = _this$props4.startFormatter,
          endFormatter = _this$props4.endFormatter,
          rest = _objectWithoutProperties(_this$props4, ["startName", "endName", "startDate", "endDate", "dateFormat", "startPlaceholder", "endPlaceholder", "startFormatter", "endFormatter"]);

      var _this$state2 = this.state,
          focusedInput = _this$state2.focusedInput,
          start = _this$state2.start,
          end = _this$state2.end;

      var pickerProps = _objectSpread({
        ref: this.dayPickerRangeController,
        navPrev: React.createElement(LeftPaginationArrow, null),
        navNext: React.createElement(RightPaginationArrow, null),
        keepOpenOnDateSelect: true,
        numberOfMonths: 2,
        isOutsideRange: this.isOutsideRange,
        startDate: startDate,
        endDate: endDate,
        focusedInput: focusedInput
      }, omit(rest, 'isManuallyEditable', 'minDate', 'maxDate', 'keyboardNavigationEnabled', 'selectMode'), {
        // Intercept original onDatesChange for some automagic
        onDatesChange: this.onDatesChange
      });

      var startValue = start; // eslint-disable-next-line max-len

      if (startValue === null) if (startFormatter) startValue = startFormatter(startDate, dateFormat);else startValue = startDate ? startDate.format(dateFormat) : '';
      var endValue = end;
      if (endValue === null) if (endFormatter) endValue = endFormatter(endDate, dateFormat);else endValue = endDate ? endDate.format(dateFormat) : '';
      return React.createElement("div", {
        className: "DayPicker"
      }, React.createElement(ClickOutside, {
        onClickOutside: this.blur
      }, React.createElement("section", {
        className: "DateInput-section"
      }, React.createElement(Row, null, React.createElement(Col, {
        xs: 6,
        className: "DateInput-container in-range dash-after"
      }, React.createElement("input", {
        type: "text",
        ref: function ref(c) {
          return _this2.startDateInput = c;
        },
        name: startName,
        value: startValue,
        onChange: this.handleManuallyChange('start'),
        className: "form-control",
        onFocus: this.focus,
        placeholder: startPlaceholder,
        onKeyDown: this.handleKeyDown
      }), React.createElement(CalendarIcon, null)), React.createElement(Col, {
        xs: 6,
        className: "DateInput-container in-range"
      }, React.createElement("input", {
        type: "text",
        ref: function ref(c) {
          return _this2.endDateInput = c;
        },
        name: endName,
        value: endValue,
        onChange: this.handleManuallyChange('end'),
        className: "form-control",
        onFocus: this.focusEnd,
        placeholder: endPlaceholder,
        onKeyDown: this.handleKeyDown
      }), React.createElement(CalendarIcon, null))), focusedInput && React.createElement(DayPickerRangeController, pickerProps))));
    }
  }]);

  return RangeDateInput;
}(Component);

_defineProperty(RangeDateInput, "propTypes", {
  startName: PropTypes.string.isRequired,
  endName: PropTypes.string.isRequired,
  startDate: PropTypes.instanceOf(moment),
  endDate: PropTypes.instanceOf(moment),
  minDate: PropTypes.instanceOf(moment),
  maxDate: PropTypes.instanceOf(moment),
  onDatesChange: PropTypes.func,
  dateFormat: PropTypes.string,
  isManuallyEditable: PropTypes.bool,
  startPlaceholder: PropTypes.string,
  endPlaceholder: PropTypes.string,
  keyboardNavigationEnabled: PropTypes.bool,
  selectMode: PropTypes.oneOf(['day', 'week', 'release week', 'month', 'quarter', 'year']),
  startFormatter: PropTypes.func,
  endFormatter: PropTypes.func
});

_defineProperty(RangeDateInput, "defaultProps", {
  startDate: null,
  endDate: null,
  minDate: null,
  maxDate: null,
  onDatesChange: noop,
  dateFormat: 'MM/DD/YYYY',
  isManuallyEditable: false,
  // preserve old behaviour
  startPlaceholder: null,
  endPlaceholder: null,
  keyboardNavigationEnabled: false,
  selectMode: 'day',
  startFormatter: null,
  endFormatter: null
});

export { RangeDateInput as default };